module.exports = __webpack_public_path__ + "media/ihh_ca_burro.4b38f58e.mp3";